// extracted by mini-css-extract-plugin
export default {"navLink":"navigationLink_navLink__ORJOS","navLinkActive":"navigationLink_navLinkActive__aBNOr"};